/**
 * TraegervereineGrid — Firestore-Objekte, "logo" ist eine direkte Storage-URL.
 * Jeder Verein: { id, name, logo (URL, optional), url (optional) }
 * Ohne Logo wird der Vereinsname als Text angezeigt (Fallback).
 */
export default function TraegervereineGrid({ vereine }) {
  if (!vereine || vereine.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
      {vereine.map((v) => {
        const content = (
          <div className="flex items-center justify-center gap-3 bg-white p-5 border border-black/5 shadow-sm hover:shadow-md hover:border-primary/30 transition-all h-28">
            {v.logo ? (
              <img
                src={v.logo}
                alt={v.name}
                loading="lazy"
                decoding="async"
                className="max-h-14 max-w-full object-contain"
              />
            ) : (
              <span className="font-bold text-sm uppercase tracking-wide text-center">
                {v.name}
              </span>
            )}
          </div>
        );

        return v.url ? (
          <a key={v.id} href={v.url} target="_blank" rel="noopener noreferrer" title={v.name}>
            {content}
          </a>
        ) : (
          <div key={v.id} title={v.name}>
            {content}
          </div>
        );
      })}
    </div>
  );
}
